export const MEMBERSHIP = {
  ANNUAL: 'annual',
  MONTHLY: 'monthly',
};

export const PLAN_CODES = {
  PREMIUM: 'CN_PREMIUM_MEMBERSHIP',
  BASIC: 'CN_BASIC_MEMBERSHIP_NO_FEE',
  COMPLIMENTARY: 'CN_PREMIUM_COMPED_SERVICES',
};

export const PLAN_CURRENCY_CODE = {
  ULTIMATE_ANNUAL: 'ULTIMATE_ANNUAL',
  ULTIMATE_MONTHLY: 'ULTIMATE_MONTHLY',
  PREMIUM_ANNUAL: 'PREMIUM_ANNUAL',
  PREMIUM_MONTHLY: 'PREMIUM_MONTHLY',
  BASIC: 'BASIC',
};

export const APPLE_PAY = 'Apple Pay';
export const PAYPAL = 'PayPal';
